import { Dashboard } from '@carbon/icons-react';
import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { NavbarItem } from 'vet-bones/components';

import { NAVBAR_SDU_DASHBOARD_BUTTON } from 'src/ui/constants/testIds';
import * as copy from 'src/ui/templates/copy';

export const useNavbarSduDashboardSchema = (): NavbarItem[] => {
  const history = useHistory();
  const location = useLocation();

  const pathname = location.pathname ?? '';

  return React.useMemo(
    () => [
      {
        active: pathname === '/units' || pathname.startsWith('/units/'),
        icon: Dashboard,
        label: copy.components.navbar.sduDashboard,
        onClick: () => history.push('/units'),
        testId: NAVBAR_SDU_DASHBOARD_BUTTON,
      },
    ],
    [history, pathname]
  );
};
